const forecastInactiveAlert = [
  ["2024-06-02", "2.0"],
  ["2024-06-09", "8.0"],
  ["2024-06-16", "42.0"],
  ["2024-06-23", "72.0"],
  ["2024-06-30", "13828.0"],
  ["2024-07-07", "4076.0"],
  ["2024-07-14", "1347.0"],
  ["2024-07-21", "3025.0"],
  ["2024-07-28", "3494.0"],
  ["2024-08-04", "8213.0"],
  ["2024-08-11", "4365.0"],
  ["2024-08-18", "2389.0"],
  ["2024-08-18", "546.0"],
  ["2024-08-25", "554.0"],
  ["2024-09-01", "415.0"],
  ["2024-09-08", "732.0"],
  ["2024-09-15", "460.0"],
  ["2024-09-22", "361.0"],
  ["2024-09-29", "358.0"],
  ["2024-10-06", "375.0"],
  ["2024-10-13", "695.0"],
  ["2024-10-20", "1701.0"],
];

const forecastIdleUser = [
  ["2024-06-02", "99.0"],
  ["2024-06-09", "629.0"],
  ["2024-06-16", "647.0"],
  ["2024-06-23", "607.0"],
  ["2024-06-30", "903.0"],
  ["2024-07-07", "805.0"],
  ["2024-07-14", "913.0"],
  ["2024-07-21", "2230.0"],
  ["2024-07-28", "1241.0"],
  ["2024-08-04", "1087.0"],
  ["2024-08-11", "1073.0"],
  ["2024-08-18", "710.0"],
  ["2024-08-18", "185.0"],
  ["2024-08-25", "206.0"],
  ["2024-09-01", "160.0"],
  ["2024-09-08", "212.0"],
  ["2024-09-15", "164.0"],
  ["2024-09-22", "851.0"],
  ["2024-09-29", "194.0"],
  ["2024-10-06", "213.0"],
  ["2024-10-13", "215.0"],
  ["2024-10-20", "155.0"],
];

const forecastFrequentPerdiodics = [
  ["2024-06-02", "0.0"],
  ["2024-06-09", "0.0"],
  ["2024-06-16", "1.0"],
  ["2024-06-23", "0.0"],
  ["2024-06-30", "1.0"],
  ["2024-07-07", "1.0"],
  ["2024-07-14", "1.0"],
  ["2024-07-21", "0.0"],
  ["2024-07-28", "0.0"],
  ["2024-08-04", "1.0"],
  ["2024-08-11", "0.0"],
  ["2024-08-18", "0.0"],
  ["2024-08-18", "0.0"],
  ["2024-08-25", "0.0"],
  ["2024-09-01", "0.0"],
  ["2024-09-08", "0.0"],
  ["2024-09-15", "0.0"],
  ["2024-09-22", "0.0"],
  ["2024-09-29", "0.0"],
  ["2024-10-06", "0.0"],
  ["2024-10-13", "0.0"],
  ["2024-10-20", "0.0"],
];

const forecastLatencyPacketLoss = [
  ["2024-06-02", "0.0"],
  ["2024-06-09", "109.0"],
  ["2024-06-16", "357.0"],
  ["2024-06-23", "162.0"],
  ["2024-06-30", "641.0"],
  ["2024-07-07", "1035.0"],
  ["2024-07-14", "831.0"],
  ["2024-07-21", "2141.0"],
  ["2024-07-28", "1673.0"],
  ["2024-08-04", "2650.0"],
  ["2024-08-11", "2598.0"],
  ["2024-08-18", "3479.0"],
  ["2024-08-18", "519.0"],
  ["2024-08-25", "618.0"],
  ["2024-09-01", "408.0"],
  ["2024-09-08", "381.0"],
  ["2024-09-15", "496.0"],
  ["2024-09-22", "394.0"],
  ["2024-09-29", "367.0"],
  ["2024-10-06", "407.0"],
  ["2024-10-13", "504.0"],
  ["2024-10-20", "1150.0"],
];

const forecastAlertSum = [
  ["2024-06-02", "202.0"],
  ["2024-06-09", "1352.0"],
  ["2024-06-16", "2040.0"],
  ["2024-06-23", "1759.0"],
  ["2024-06-30", "20108.0"],
  ["2024-07-07", "7204.0"],
  ["2024-07-14", "4017.0"],
  ["2024-07-21", "7963.0"],
  ["2024-07-28", "7374.0"],
  ["2024-08-04", "13555.0"],
  ["2024-08-11", "9213.0"],
  ["2024-08-18", "7208.0"],
  ["2024-08-18", "1524.0"],
  ["2024-08-25", "1621.0"],
  ["2024-09-01", "1239.0"],
  ["2024-09-08", "1587.0"],
  ["2024-09-15", "1584.0"],
  ["2024-09-22", "1566.0"],
  ["2024-09-29", "1154.0"],
  ["2024-10-06", "1266.0"],
  ["2024-10-13", "1746.0"],
  ["2024-10-20", "3124.0"],
];

const forecastTicketCount = [
  ["2024-06-02", "28.0"],
  ["2024-06-09", "194.0"],
  ["2024-06-16", "175.0"],
  ["2024-06-23", "217.0"],
  ["2024-06-30", "211.0"],
  ["2024-07-07", "230.0"],
  ["2024-07-14", "240.0"],
  ["2024-07-21", "201.0"],
  ["2024-07-28", "200.0"],
  ["2024-08-04", "248.0"],
  ["2024-08-11", "236.0"],
  ["2024-08-18", "162.0"],
  ["2024-08-18", "25.0"],
  ["2024-08-25", "41.0"],
  ["2024-09-01", "34.0"],
  ["2024-09-08", "34.0"],
  ["2024-09-15", "32.0"],
  ["2024-09-22", "36.0"],
  ["2024-09-29", "34.0"],
  ["2024-10-06", "34.0"],
  ["2024-10-13", "38.0"],
  ["2024-10-20", "34.0"],
];

export {
  forecastAlertSum,
  forecastTicketCount,
  forecastFrequentPerdiodics,
  forecastIdleUser,
  forecastInactiveAlert,
  forecastLatencyPacketLoss,
};
